'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { TabsSelect } from '~/components/component-library/Tabs/components/TabsSelect'
import { TabsListVariantContext } from '~/components/component-library/Tabs/context'
import {
  TABS_LIST_CLASSNAME,
  TABS_LIST_DEFAULT_SELECT_FRAME_CLASSNAME,
  TABS_LIST_DENSE_RULE_CLASSNAME,
  TABS_LIST_TABLE_FRAME_CLASSNAME,
  TABS_LIST_TABLE_SELECT_FRAME_CLASSNAME,
} from '~/components/component-library/Tabs/styles'
import { type TabsListProps } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

export const TabsList = ({
  ref,
  variant = 'default',
  className,
  children,
  ...props
}: TabsListProps) => {
  const list = (
    <TabsPrimitive.List
      ref={ref}
      className={cn(TABS_LIST_CLASSNAME[variant], className)}
      {...props}
    >
      {children}
    </TabsPrimitive.List>
  )

  const select = <TabsSelect>{children}</TabsSelect>

  const wrapped =
    variant === 'table' ? (
      <div className={TABS_LIST_TABLE_FRAME_CLASSNAME}>
        <div className={TABS_LIST_TABLE_SELECT_FRAME_CLASSNAME}>{select}</div>
        {list}
      </div>
    ) : variant === 'dense' ? (
      <>
        {list}
        <div className={TABS_LIST_DENSE_RULE_CLASSNAME} />
      </>
    ) : (
      // One wrapper so a parent's space-y doesn't push the row down on desktop
      <div>
        <div className={TABS_LIST_DEFAULT_SELECT_FRAME_CLASSNAME}>{select}</div>
        {list}
      </div>
    )

  return (
    <TabsListVariantContext value={variant}>{wrapped}</TabsListVariantContext>
  )
}
